<template>
    <div ref="pieChartLocation"></div>
</template>

<script>
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";

export default {
    props : ['datas'],
    data(){
        return {
            chart : null
        }
    },
    mounted(){
        this.createChart();
        this.loadData();
    },
    watch : {
        '$store.state.updateData' : function(){
            this.loadData();
        }
    },
    methods : {
        createChart(){
            this.chart = am4core.create(this.$refs.pieChartLocation, am4charts.PieChart);

            let title = this.chart.titles.create();
            title.text = "Replaced QR By Location";
            title.fontSize = 25;
            title.marginBottom = 30;

            let pieSeries = this.chart.series.push(new am4charts.PieSeries());
            pieSeries.dataFields.value = "replaced";
            pieSeries.dataFields.category = "loc_code";
            pieSeries.slices.template.stroke = am4core.color("#fff");
            pieSeries.slices.template.strokeWidth = 2;
            pieSeries.slices.template.strokeOpacity = 1;
            pieSeries.labels.template.text = "";


            // This creates initial animation
            pieSeries.hiddenState.properties.opacity = 1;
            pieSeries.hiddenState.properties.endAngle = -90;
            pieSeries.hiddenState.properties.startAngle = -90;

            // Creates the legend
            this.chart.legend = new am4charts.Legend();
        },
        loadData() {
            let length = this.chart.data.length;

            this.chart.addData(this.datas , length);
        }
    }
}
</script>